<script>
import _ from 'lodash'

export default {
  name: 'table-input',
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },

    default: {
      type: Array,
      default: () => {
        return []
      }
    },

    readonly: {
      type: Boolean,
      default: false
    },

    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      dialog: false,
      copyBox: false,
      pastedValues: '',
      headers: this.getHeader(),
      items: this.initItems(),
      editedIndex: -1,
      on: false,
      showTable: false
    }
  },

  computed: {
    formTitle() {
      return this.readonly
        ? 'Display value'
        : this.editedIndex === -1
        ? 'Add new value'
        : 'Change value'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    value() {
      this.initItems()
    }
  },

  methods: {
    close() {
      this.dialog = false
    },

    checkArray(value) {
      return _.isArray(value) && !_.isNull(value) && !_.isUndefined(value)
    },

    checkObject(value) {
      return _.isObject(value) && !_.isNull(value) && !_.isUndefined(value)
    },

    initItems() {
      if (this.default && this.default.length > 0) {
        return JSON.parse(JSON.stringify(this.default))
      } else if (this.value && this.value.length > 0) {
        let tableItems = []
        this.value.map(i => {
          tableItems.push(this.getDefaultsForDisplay(i))
        })
        return JSON.parse(JSON.stringify(tableItems))
      } else {
        return []
      }
    },

    getHeader() {
      if (this.options.deepStructure) {
        return this.options.deepStructure
          .map(function(column) {
            return {
              text: column.options.label || column.key,
              value: column.options.label || column.key
            }
          })
          .concat({
            text: 'Actions',
            value: ''
          })
      } else if (_.isArray(this.value) && this.value.length > 0) {
        let headerArray = []
        if (_.isString(this.value[0])) {
          let headerItem = {}
          headerItem.text = 0
          headerItem.value = 0
          headerArray.push(headerItem)
        } else if (_.isObject(this.value[0])) {
          for (let [key, value] of Object.entries(this.value[0])) {
            if (this.value[0].hasOwnProperty(key)) {
              let headerItem = {}
              headerItem.text = key
              headerItem.value = key
              headerArray.push(headerItem)
            }
          }
        }
        let headerItem = {}
        headerItem.text = 'Actions'
        headerItem.value = ''
        headerArray.push(headerItem)
        return headerArray
      } else {
        return []
      }
    },

    save(item) {
      if (this.editedIndex > -1) {
        Object.assign(
          this.items[this.editedIndex],
          JSON.parse(JSON.stringify(item))
        )
      } else {
        this.items.push(JSON.parse(JSON.stringify(item)))
      }
      this.editedIndex = -1
      this.$emit('input', this.items)
      this.dialog = false
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item)
      this.dialog = true
    },

    clearAllInputs() {
      this.items = []
    },

    convertCSV() {
      let values = this.pastedValues.split(/[\s,]+/)
      let self = this
      values.forEach(f => {
        self.items.push(
          JSON.parse(
            '{ "' + self.options.deepStructure[0].key + '": "' + f + '" }'
          )
        )
      })
      this.$emit('input', this.items)
      this.copyBox = false
    },

    deleteItem(item) {
      const index = this.items.indexOf(item)
      this.items.splice(index, 1)
      this.$emit('input', this.items)
    },

    getItemSchema(index) {
      // return a list of property fields
      if (this.options.deepStructure) {
        var fields = this.options.deepStructure.map(field => {
          var f = {
            ...field
          }
          if (this.editedIndex > -1) {
            f.default = f.default || this.items[index][field.key]
          }

          return f
        }, this)

        return fields
      } else if (index >= 0) {
        return this.getFieldsForDisplay(this.items[index])
      } else if (index === -1) {
        return this.getFieldsForDisplay(this.items[0])
      } else {
        return []
      }
    },

    getDefaultsForDisplay(object) {
      let itemArray = []
      if (_.isString(object)) {
        itemArray.push(object)
      } else if (_.isObject(object)) {
        for (let [key, value] of Object.entries(object)) {
          if (object.hasOwnProperty(key)) {
            itemArray.push(value)
          }
        }
      }
      return itemArray
    },

    getFieldsForDisplay(object) {
      let itemArray = []
      if (_.isString(object)) {
        let formItem = {}
        formItem.key = 0
        formItem.options = {}
        formItem.options.label = 0
        formItem.type = 'text'
        formItem.default = object
        itemArray.push(formItem)
      } else if (_.isObject(object)) {
        for (let [key, value] of Object.entries(object)) {
          if (object.hasOwnProperty(key)) {
            let formItem = {}
            formItem.key = key
            formItem.options = {}
            formItem.options.label = key

            if (_.isArray(value)) {
              formItem.type = 'array'
              let tableItems = []
              value.map(i => {
                tableItems.push(this.getDefaultsForDisplay(i))
              })
              formItem.default = tableItems
              formItem.options.deepStructure =
                value.length > 0 ? this.getFieldsForDisplay(value[0]) : []
            } else if (_.isString(value)) {
              formItem.type = 'text'
              formItem.default = value
            } else if (_.isUndefined(value)) {
              formItem.type = 'text'
              formItem.default = ''
            } else if (_.isNull(value)) {
              formItem.type = 'text'
              formItem.default = ''
            } else if (_.isObject(value)) {
              formItem.type = 'object'
              formItem.default = value
              formItem.options.deepStructure = this.getFieldsForDisplay(value)
            } else {
              formItem.type = 'text'
              formItem.default = value
            }
            itemArray.push(formItem)
          }
        }
      }
      return itemArray
    },

    getNewItemSchema() {
      return this.options.deepStructure
    }
  },
  components: {
    FormGenerator: () => import('./FormGenerator')
  }
}
</script>

<template>
  <v-layout row wrap>
    <v-flex xs12 class="beez-padding-tb">
      <v-card>
        <v-toolbar
          dense
          card
          class="elevation-2"
          @click="showTable = !showTable"
        >
          <v-toolbar-title
            class="body-2 beez-bold"
            v-text="'Multi-Value Input | ' + options.label"
          />
          <span class="beez-bold pl-1">({{ items.length }})</span>
          <v-spacer></v-spacer>
          <v-btn flat small icon @click.stop="clearAllInputs" v-if="!readonly">
            <v-icon>delete_sweep</v-icon>
          </v-btn>
          <v-dialog v-model="copyBox" v-if="!readonly">
            <template slot="activator" slot-scope="{ on }">
              <v-btn icon small class="mb-2" v-on="on">
                <v-icon>move_to_inbox</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-toolbar dense>
                <span class="beez-bold"
                  >Copy and paste multiple values of {{ options.label }}</span
                >
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-textarea
                        outline
                        color="secondary"
                        :label="options.label"
                        v-model="pastedValues"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-layout row>
                  <v-flex xs12>
                    <v-btn
                      class="text-capitalize"
                      :outline="$vuetify.dark"
                      @click="copyBox = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      v-if="!readonly"
                      :outline="$vuetify.dark"
                      class="text-capitalize"
                      @click="convertCSV"
                      :class="
                        $vuetify.dark
                          ? 'secondary text-capitalize'
                          : 'primary text-capitalize'
                      "
                    >
                      Submit
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog" max-width="1000">
            <template slot="activator" slot-scope="{ on }" v-if="!readonly">
              <v-btn
                flat
                icon
                small
                class="mb-2"
                v-on="on"
                @click.stop="editedIndex = -1"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <v-card v-if="dialog">
              <v-toolbar dense>
                <span class="beez-bold text-capitalize">{{ formTitle }}</span>
                <v-spacer />
                <v-btn flat icon @click="close">
                  <v-icon>
                    close
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-flex xs12 sm12 md12>
                  <form-generator
                    :key="'formGenerator' + 0"
                    :schema="getItemSchema(editedIndex)"
                    :readonly="readonly"
                    @submit="save"
                    @cancel="close"
                  />
                </v-flex>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-btn icon small class="mb-2">
            <v-icon
              >{{ showTable ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-if="showTable">
          <v-data-table :headers="headers" :items="items">
            <template slot="items" slot-scope="props">
              <tr>
                <td
                  :key="index + 'td'"
                  v-for="(item, index) in props.item"
                  class="text-right"
                >
                  <v-flex v-if="checkArray(item)">
                    <v-btn small icon flat @click="editItem(props.item)">
                      <v-icon>
                        table_chart
                      </v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex v-else-if="checkObject(item)">
                    <v-btn small icon flat @click="editItem(props.item)">
                      <v-icon @click="editItem(props.item)">
                        web
                      </v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <div style="text-align: left;">
                      {{ item }}
                    </div>
                    <!-- Todo: Table content goes here -->
                  </v-flex>
                </td>
                <v-spacer />
                <div v-if="!readonly">
                  <td class="text-left">
                    <v-btn
                      small
                      icon
                      flat
                      class="mr-2 mt-2"
                      @click.stop="editItem(props.item)"
                    >
                      <v-icon small>
                        edit
                      </v-icon>
                    </v-btn>

                    <v-btn
                      small
                      icon
                      flat
                      class="mt-2"
                      @click="editItem(props.item)"
                    >
                      <v-icon small @click.stop="deleteItem(props.item)">
                        delete
                      </v-icon>
                    </v-btn>
                  </td>
                </div>
                <div v-else>
                  <td class="text-left">
                    <v-btn
                      small
                      icon
                      flat
                      class="mt-2"
                      @click="editItem(props.item)"
                    >
                      <v-icon>
                        remove_red_eye
                      </v-icon>
                    </v-btn>
                  </td>
                </div>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
